import { gql, useMutation, useQuery } from '@apollo/client'
import sumBy from 'lodash/sumBy'

import {
  AnswerItemCollectMission,
  AnswerItemCollectMissionMutation,
  AnswerItemCollectMissionMutationVariables,
  ItemMissionsQuery,
  ItemMissionsQueryVariables,
  RelatedMissionDetailFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { router, generatePath, routerPages } = useRouter<{ itemId: string }>()

  const { data } = useQuery<ItemMissionsQuery, ItemMissionsQueryVariables>(
    QUERY,
    { variables: { itemId: router.query.itemId } }
  )

  const [answerItemCollectMission] = useMutation<
    AnswerItemCollectMissionMutation,
    AnswerItemCollectMissionMutationVariables
  >(AnswerItemCollectMission, {
    onCompleted(data) {
      if (!data?.answerItemCollectMission.correct) {
        return
      }
      return router.push(
        generatePath(routerPages.MissionAccomplished, {
          missionId: data.answerItemCollectMission.missionId,
        })
      )
    },
  })

  return {
    state: {
      relatedMissions: data?.item?.relatedMissions ?? null,
    },
    actions: {
      async onSubmitAnswerItem(missionId) {
        const { data } = await answerItemCollectMission({
          variables: { missionId },
        })
        return (
          sumBy(
            data?.answerItemCollectMission?.lackItems ?? [],
            'requiredCount'
          ) ?? 0
        )
      },
    },
  }
})

const QUERY = gql`
  query ItemMissions($itemId: ID!) {
    item(id: $itemId) {
      id
      relatedMissions {
        ...RelatedMissionDetail
      }
    }
  }
  ${RelatedMissionDetailFragmentDoc}
`
